<template>
  <div>
    <div class="auth-wrapper">
      <span class="session-expired">{{ message }}</span>
      <amplify-authenticator
        id="auth"
        :authConfig="configurationOptions"
        usernameAlias="email"
        slot="sign-in"
      >
      </amplify-authenticator>
    </div>
    <div class="footer">
      <section>
        <ul class="inline-list">
          <li>
            <router-link to="/impressum">Impressum</router-link>
          </li>
          <li>
            <router-link to="/privacy">Datenschutzerklärung</router-link>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
const authTheme = {
  button: {
    backgroundColor: 'blue',
  },
};
export default {
  name: 'Auth',
  props: ['message'],
  data() {
    return {
      configurationOptions: {
        signInConfig: {
          isSignUpDisplayed: false,
          theme: authTheme,
        },
      },
    };
  },
};
</script>

<style scoped>
.auth-wrapper {
  margin: 0 auto;
  padding-top: 100px;
  width: 100%;
  text-align: center;
  max-width: calc(100% - 60%);
}

.Anchor__a___3JUCG {
  color: #2196f3;
}

.session-expired {
  font-size: 20px;
}

/**.

Navbar

 */

@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
@import 'https://fonts.googleapis.com/css?family=Hammersmith+One|Nunito|Orbitron:500|Poiret+One';

/*
font-family: 'Orbitron', sans-serif;
font-family: 'Hammersmith One', sans-serif;
font-family: 'Poiret One', cursive;
font-family: 'Nunito', sans-serif;
*/

.nav {
  display: block;
  background-color: #1f2532;
  color: #f3f7ea;
  width: 100%;
  padding: 14px;
  height: fit-content;
  padding-bottom: 0;
}
.menu1-bar {
  text-transform: uppercase;
  font-size: 10px;
}
.menu2-bar {
  text-transform: uppercase;
  font-size: 12px;
}
.logo-wrapper {
  width: 100%;
  padding-top: 44px;
  margin-left: 10%;
  height: 193px;
  padding-bottom: 36px;
}
.nav .logo {
  float: left;
  font-size: 19px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  line-height: 21px;
  width: 34px;
  border-radius: 5px;
  color: white;
  background-color: rgb(255, 51, 102);
  text-align: left;
  padding: 5px 10px 1px 9px;
}
.title {
  float: left;
  margin: 0 20px 0 0;
  font-size: 33px;
  padding-right: 23px;
  line-height: 33px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  font-family: 'Nunito', sans-serif;
  color: white;
  width: 100%;
  line-height: 70px;
}

.nav ul li {
  list-style: none;
  display: inline;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #9aa4b3;
  cursor: pointer;
}

.nav ul {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  height: 33px;
}

.nav ul li a {
  text-decoration: none;
  display: block;
  height: 31px;
}

.nav ul li a.active {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  display: block;
  height: 29px;
}

.nav ul li a:hover {
  color: #ffff;
}

.nav ul li a:visited {
  color: #9aa4b3;
  text-decoration: none;
}

.nav .list-item {
  margin: 0 45px 0 0;
  display: inline-block;
}

.nav .menu2-bar .list-item {
  margin: 0 118px 0 0;
  vertical-align: top;
}

.nav .menu2-bar .list-item.active {
  margin: 0 75px 0 0;
  border-bottom: solid 2px rgb(255, 51, 102);
  color: #ffff;
}

.nav .Button__button___1FrBC {
  float: right;
  background: none;
  border: none;
  text-transform: none;
  color: #9aa4b3;
  display: inline;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  color: #9aa4b3;
  cursor: pointer;
  padding: none;
}

.nav ul li a.more {
  /*background-image: url("../assets/tree-dots.png");*/
  display: inline-block;
  width: 30px;
  height: 22px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: -4px 4px;
}

.toggle-list-wrapper .item.more {
  /*background-image: url("../assets/tree-dots.png");*/
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
}

.toggle-list-wrapper .item.more:hover {
  background-color: #fff;
}

.nav ul li a.more:hover {
  background-position: -62px 3px;
}

.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toggle-list-wrapper .item {
  cursor: pointer;
  padding: 9px 23px;
  text-align: left;
  height: fit-content;
  margin: 0;
  font-weight: 300;
  color: #464d5d;
  font-size: 11px;
}
.toggle-list-wrapper .item.last-item {
  border-top: solid 1px #e1e4ea;
}

.toggle-list-wrapper .item:hover {
  background-color: #f0f0f0;
}

.codelos-logo {
  float: left;
  font-size: 19px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
  width: 55px;
  border-radius: 19px;
  color: white;
  background-color: rgb(255, 51, 102);
  text-align: left;
  padding: 5px 10px 1px 9px;
  transform: rotate(-10deg);
}

/**.

end Navbar

 */

#auth {
  width: 100%;
  padding: 5px;
}

#auth .Form__formSection___3tqxz {
  min-width: 300px !important;
}

@media (max-width: 414px) {
  .logo-wrapper {
    margin-left: 6%;
  }
}

@media (min-width: 414px) {
  .logo-wrapper {
    margin-left: 10%;
  }
}

:root {
  --amazonOrange: #ff3366;
  --button-background-color: #ff3366;
  --green: #09baa6;
  --green-darker: #00a08e;
  --link-color: none;
}

.footer {
  position: fixed;
  bottom: 0;
}

.footer .inline-list {
  list-style: unset;
}

.footer .inline-list li {
  display: inline-block;
  margin-right: 15px;
}

.footer .inline-list li a {
  color: black;
}

.footer .inline-list li a:hover {
  text-decoration: underline;
}
</style>
